import React from 'react';
import PropTypes from 'prop-types';
import { Router, Route, IndexRoute } from 'react-router';

// Containers
import App from './container/app';
import Home from './container/home';
import ArticleContentItem from './container/articleContentItem';
import SectionContentItem from './container/sectionContentItem';
import ForOFor from './container/forOFor';
import Preview from './container/preview';
import SearchResults from './container/searchResults';
import Playlist from './container/playlist';
import TrafficList from './container/traffic/list';
import TrafficDetail from './container/traffic/detail';
import ContentItem from './container/contentItem';
import AuthorArticles from './container/authorArticles';

const Routes = (props) => {
  return (
    <Router {...props}>
      <Route path="/playlist" component={Playlist} />
      <Route
        path="/"
        component={App}
        onChange={(prevState, nextState) => {
          if (typeof window !== 'undefined' && window && window.ga) {
            window.ga('set', 'page', nextState.location.pathname);
            window.ga('send', 'pageview');
          }
          if (nextState.location.action !== 'POP') {
            if (window.innerWidth < 1200) {
              let header = document.getElementById('header');
              if (header) {
                let rect = header.getBoundingClientRect();
                window.scroll({
                  left: 0,
                  top: rect.height,
                  behavior: 'smooth',
                });
              } else {
                window.scroll({ left: 0, top: 0, behavior: 'smooth' });
              }
            } else {
              window.scroll({ left: 0, top: 0, behavior: 'smooth' });
            }
          }
        }}
      >
        <IndexRoute component={Home} />
        <Route path="preview" component={Preview} />
        <Route path="clanok/:id" component={ArticleContentItem} />
        <Route path="sekcia/:id" component={SectionContentItem} />
        <Route path="vyhladavanie" component={SearchResults} />
        <Route path="dopravny-servis" component={TrafficList} />
        <Route path="dopravny-servis/:id" component={TrafficDetail} />
        <Route path="autor/:authorName" component={AuthorArticles} />
        <Route path="404" component={ForOFor} />
        <Route path="*" component={ContentItem} />
      </Route>
    </Router>
  );
};

export default Routes;

Routes.propTypes = {
  store: PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/app/Routes.js